import React, { useEffect, useState } from "react";

// Defina a duração que o vídeo deve aparecer na tela (em milissegundos)
const SPLASH_DURATION = 5000; // 5 segundos
const FADE_OUT_DURATION = 500; // 0.5 segundos

const SplashScreen: React.FC<{ onFinish: () => void }> = ({ onFinish }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Timer para iniciar o fade-out
    const fadeOutTimer = setTimeout(() => {
      setFadeOut(true);

      // Timer para chamar onFinish() após o término da animação de fade-out
      const finishTimer = setTimeout(() => {
        onFinish();
      }, FADE_OUT_DURATION);

      return () => clearTimeout(finishTimer);
    }, SPLASH_DURATION);

    return () => clearTimeout(fadeOutTimer);
  }, [onFinish]);

  return (
    <div
      className={`fixed inset-0 z-[9999] bg-grafite transition-opacity ease-in-out ${
        fadeOut ? "opacity-0" : "opacity-100"
      }`}
      style={{ transitionDuration: `${FADE_OUT_DURATION}ms` }}
      aria-label="Abertura do site Larissa Godoy"
      aria-busy="true"
    >
      {/* Overlay para escurecer o vídeo e melhorar o contraste */}
      <div className="absolute inset-0 bg-black/30 z-10" />

      {/* Imagem de fundo para mobile */}
      <div
        className="absolute inset-0 w-full h-full bg-cover bg-center md:hidden"
        style={{ backgroundImage: "url('/casav1_mobile.png')" }}
      />

      {/* Elemento de Vídeo para desktop */}
      <video
        src="/splash-video (1).mp4" // << Certifique-se que este é o nome do seu vídeo na pasta 'public'
        autoPlay
        muted
        loop
        playsInline // Essencial para autoplay em dispositivos iOS
        className="absolute inset-0 w-full h-full object-cover z-0 hidden md:block"
      />
    </div>
  );
};

export default SplashScreen;